import { render, staticRenderFns } from "./new-user-role.vue?vue&type=template&id=0941a31d&scoped=true&"
import script from "./new-user-role.vue?vue&type=script&lang=js&"
export * from "./new-user-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0941a31d",
  null
  
)

export default component.exports